import { React, useState, useEffect } from 'react';
import axios from 'axios';
import apiUrl from '../../../apiConfig';
import EmailInput from './EmailInput';
import RegistrationModal from './RegistrationModal';
import RenewalModal from './RenewalModal';
import RegistrantUpdateModal from './RegistrantUpdateModal';
import { Row, Container, Button, Col } from 'react-bootstrap';
import ScoresModal from './ScoresModal';
import TermsModal from './Terms/TermsModal';

const PlayerAuth = (props) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [needToRegister, setNeedToRegister] = useState(false);
    const [needToRenew, setNeedToRenew] = useState(false);
    const [needToUpdate, setNeedToUpdate] = useState(false);
    const [registrant, setRegistrant] = useState({});
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [email, setEmail] = useState('');
    const [scoresModal, setScoresModal] = useState(false);
    const [termsModal, setTermsModal] = useState(false);
    const [noMorePlays, setNoMorePlays] = useState(false);

    const promptRegistration = (email) => {
        setNeedToRegister(true);
        setEmail(email);
    }

    const closeRegistration = () => {
        setNeedToRegister(false);
        setEmail('');
    }

    const promptRenewRegistration = (email) => {
        setNeedToRenew(true);
        setEmail(email);
    }

    const closeRenewal = () => {
        setNeedToRenew(false);
        setEmail('');
    }

    const promptUpdateRegistration = (registrationFields) => {
        setNeedToUpdate(true);
        setEmail(registrationFields.email);
        setRegistrant(registrationFields);
    }

    const closeUpdate = () => {
        setNeedToUpdate(false);
        setEmail('');
    }

    const openScoresModal = () => {
        setScoresModal(true);
    }

    const closeScoresModal = () => {
        setScoresModal(false);
    }

   const closeTermsModal = () => {
        setTermsModal(false);
    }

    useEffect(() => {
        axios({
            url: `${apiUrl}/plays/${props.player.email}/${props.quiz[0].id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_SECRET_KEY}`
            }
        })
            .then((res) => {
                if (res.data.data >= props.quiz[0].max_plays) {
                    setNoMorePlays(true);
                }
            })
            .catch(() => {
                props.msgAlert({
                    heading: 'Server Error',
                    message: 'Please try again later.',
                    variant: 'danger'
                })
            })
    }, []);

    

    return (
        <>
        {termsAccepted &&
            <h1>Terms Accepted</h1>
        }
        {authenticated &&
            <Container className='d-flex flex-column'>
                <Row className="d-flex mb-3 justify-content-center">
                    {noMorePlays &&
                        <h3 style={{ textAlign: 'center' }}>Sorry, you have reached the maximum amount of plays for this game.</h3>
                    }
                    {!noMorePlays &&
                    <>
                    <Col xs={12} md={6} className="d-flex justify-content-end ">
                    <Button onClick={()=> openScoresModal()} style={{ width: '50%', borderRadius: '0' }} variant="light" className='mt-1'>Previous Scores</Button>
                    </Col>
                    <Col xs={12} md={6} className="d-flex justify-content-start">
                    <Button style={{ width: '50%', borderRadius: '0' }} variant="light" className='mt-1' onClick={!termsAccepted ? ()=> setTermsModal(true) : console.log('nothing') }>Play</Button>
                    </Col>
                    </>
                    }
                </Row>
                {scoresModal &&
                <ScoresModal {...props} scoresModal={scoresModal} closeScoresModal={closeScoresModal} />
                }
                {termsModal &&
                <TermsModal {...props} termsAccepted={termsAccepted} setTermsAccepted={setTermsAccepted} termsModal={termsModal} closeTermsModal={closeTermsModal} /> 
                }
            </Container>
        }
        {!authenticated &&
            <div>
                <EmailInput {...props} promptRegistration={promptRegistration} promptRenewRegistration={promptRenewRegistration} promptUpdateRegistration={promptUpdateRegistration} setAuthenticated={setAuthenticated}/>
                {needToRegister &&
                <RegistrationModal {...props} closeRegistration={closeRegistration} needToRegister={needToRegister} currentEmail={email} setAuthenticated={setAuthenticated}/> 
                }
                {needToRenew &&
                <RenewalModal {...props} closeRenewal={closeRenewal} needToRenew={needToRenew} currentEmail={email} setAuthenticated={setAuthenticated}/> 
                }
                {needToUpdate &&
                <RegistrantUpdateModal {...props} registrant={registrant} closeUpdate={closeUpdate} needToUpdate={needToUpdate} currentEmail={email} setAuthenticated={setAuthenticated}/> 
                }
            </div>
        }
        </>
    );
};

export default PlayerAuth;


// add max_plays column to quizzes table int11 notnull